var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parentScroll",staticClass:"scroll",style:({height:_vm.getHeight}),on:{"scroll":_vm.scrollChange}},[_c('div',{staticClass:"scroll-content",style:({width:_vm.getWidth})})])
}
var staticRenderFns = []

export { render, staticRenderFns }